import { render, staticRenderFns } from "./SdgTargetsPicker.vue?vue&type=template&id=f4c23140&scoped=true"
import script from "./SdgTargetsPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdgTargetsPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdgTargetsPicker.vue?vue&type=style&index=0&id=f4c23140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c23140",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Term: require('/home/runner/work/assessment-service/assessment-service/frontend/components/Term.vue').default,SDG: require('/home/runner/work/assessment-service/assessment-service/frontend/components/SDG.vue').default,IxSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionTitle.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
